import { Component } from '@angular/core';

@Component({
  selector: 'app-user-history-stats-dialog-skeleton',
  templateUrl: './user-history-stats-dialog-skeleton.component.html',
  styleUrls: ['./user-history-stats-dialog-skeleton.component.scss']
})
export class UserHistoryStatsDialogSkeletonComponent {

}
